import React, { Component } from 'react'

export default class Option extends Component {
  render() {
    const label = ["A", "B", "C", "D", "E", "F", "G", "H", "I"]
    return (
      <div className="Option">
        <hr className="d-none d-md-block" />
        <button
          className="btn btn-lg btn-secondary quiz-option"
          onClick={() => { this.props.onClick(this.props.question, this.props.answer) }}
        >
          <span className="label">
            { label[this.props.label] + ". " }
          </span>
          <span className="value">
            { this.props.value }
          </span>
        </button>
      </div>
    )
  }
}
